import {Component, input} from '@angular/core';
import {ThinkingOrbComponent} from '../thinking-orb/thinking-orb.component';

/**
 * The app-wide blocking loader: a dimmed sheet over everything, with a thinking orb in the middle.
 *
 * Mounted once, in `app.component.html`, and driven by `LoadingIndicatorService`. It is the only feedback a
 * user gets while a slow request is in flight, so a backdrop with no visible indicator is worse than no loader
 * at all — it looks like the app has hung. The template's own comment records the three separate defects that
 * each produced exactly that, and `fullscreen-loader.component.spec.ts` pins them.
 *
 * Since #775 the indicator is `<app-thinking-orb>` in `composing` mode — a dotted, undulating sash painted on
 * a 2D canvas — rather than a spinning SVG wheel. The orb is monochrome by construction, so the brand colour
 * that the old wheel carried (`text-theme-primary-700`) is deliberately gone: light ink on the existing grey
 * backdrop is the whole palette. The orb's own component owns every animation concern (the clock outside
 * `NgZone`, pausing offscreen, reduced motion); this component owns nothing but the two layers.
 *
 * No `CommonModule` import: the template uses the built-in `@if` rather than `*ngIf`.
 */
@Component({
  selector: 'app-fullscreen-loader',
  imports: [ThinkingOrbComponent],
  templateUrl: './fullscreen-loader.component.html',
  styleUrls: ['./fullscreen-loader.component.scss']
})
export class FullscreenLoaderComponent {
  /** Whether the blocking sheet is on screen. */
  readonly show = input(false);
}
